import { Pipe, PipeTransform } from '@angular/core'

import { formatBasePoints } from 'app/_shared/helpers/base-points.helpers'
import { BasePointsCurrency } from 'app/_shared/interfaces/BasePoints'

@Pipe({ name: 'basePoints' })
export class BasePointsPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    currency: BasePointsCurrency,
    useLongName = false
  ): string {
    return formatBasePoints(Number(value ?? 0), currency, useLongName)
  }
}
